"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgPermissionsValues = exports.OrgPermissionsEnum = exports.AdminPermissionsValues = exports.AdminPermissionsEnum = exports.PermissionsValues = exports.PermissionsEnum = exports.manageFunction = exports.manageCase = exports.manageAlert = void 0;
exports.manageAlert = ['create', 'delete', 'import', 'update'];
exports.manageCase = ['changeOwnership', 'create', 'delete', 'merge', 'update'];
exports.manageFunction = ['create', 'delete', 'invoke', 'update'];
var PermissionsEnum;
(function (PermissionsEnum) {
    PermissionsEnum["ACCESS_THE_HIVE_FS"] = "accessTheHiveFS";
    PermissionsEnum["MANAGE_ACTION"] = "manageAction";
    PermissionsEnum["MANAGE_ALERT_CREATE"] = "manageAlert/create";
    PermissionsEnum["MANAGE_ALERT_DELETE"] = "manageAlert/delete";
    PermissionsEnum["MANAGE_ALERT_IMPORT"] = "manageAlert/import";
    PermissionsEnum["MANAGE_ALERT_UPDATE"] = "manageAlert/update";
    PermissionsEnum["MANAGE_ALERT_RESTART"] = "manageAlert/reopen";
    PermissionsEnum["MANAGE_ANALYSE"] = "manageAnalyse";
    PermissionsEnum["MANAGE_ANALYZER_TEMPLATE"] = "manageAnalyzerTemplate";
    PermissionsEnum["MANAGE_CASE_CHANGE_OWNERSHIP"] = "manageCase/changeOwnership";
    PermissionsEnum["MANAGE_CASE_CREATE"] = "manageCase/create";
    PermissionsEnum["MANAGE_CASE_DELETE"] = "manageCase/delete";
    PermissionsEnum["MANAGE_CASE_MERGE"] = "manageCase/merge";
    PermissionsEnum["MANAGE_CASE_UPDATE"] = "manageCase/update";
    PermissionsEnum["MANAGE_CASE_REOPEN"] = "manageCase/reopen";
    PermissionsEnum["MANAGE_CASE_TEMPLATE"] = "manageCaseTemplate";
    PermissionsEnum["MANAGE_COMMENT"] = "manageComment";
    PermissionsEnum["MANAGE_CONFIG"] = "manageConfig";
    PermissionsEnum["MANAGE_CUSTOM_EVENT"] = "manageCustomEvent";
    PermissionsEnum["MANAGE_CUSTOM_FIELD"] = "manageCustomField";
    PermissionsEnum["MANAGE_FUNCTION_CREATE"] = "manageFunction/create";
    PermissionsEnum["MANAGE_FUNCTION_INVOKE"] = "manageFunction/invoke";
    PermissionsEnum["MANAGE_CASE_REPORT"] = "manageCaseReport";
    PermissionsEnum["MANAGE_CASE_REPORT_TEMPLATE"] = "manageCaseReportTemplate";
    PermissionsEnum["MANAGE_KNOWLEDGE_BASE"] = "manageKnowledgeBase";
    PermissionsEnum["MANAGE_OBSERVABLE"] = "manageObservable";
    PermissionsEnum["MANAGE_OBSERVABLE_TEMPLATE"] = "manageObservableTemplate";
    PermissionsEnum["MANAGE_ORGANISATION"] = "manageOrganisation";
    PermissionsEnum["MANAGE_PAGE"] = "managePage";
    PermissionsEnum["MANAGE_PAGE_TEMPLATE"] = "managePageTemplate";
    PermissionsEnum["MANAGE_PATTERN"] = "managePattern";
    PermissionsEnum["MANAGE_PLATFORM"] = "managePlatform";
    PermissionsEnum["MANAGE_PROCEDURE"] = "manageProcedure";
    PermissionsEnum["MANAGE_PROFILE"] = "manageProfile";
    PermissionsEnum["MANAGE_REPORT_TEMPLATE"] = "manageReportTemplate";
    PermissionsEnum["MANAGE_SHARE"] = "manageShare";
    PermissionsEnum["MANAGE_TAG"] = "manageTag";
    PermissionsEnum["MANAGE_TASK"] = "manageTask";
    PermissionsEnum["MANAGE_TAXONOMY"] = "manageTaxonomy";
    PermissionsEnum["MANAGE_USER"] = "manageUser";
})(PermissionsEnum = exports.PermissionsEnum || (exports.PermissionsEnum = {}));
exports.PermissionsValues = [
    PermissionsEnum.ACCESS_THE_HIVE_FS,
    PermissionsEnum.MANAGE_ACTION,
    PermissionsEnum.MANAGE_ALERT_CREATE,
    PermissionsEnum.MANAGE_ALERT_DELETE,
    PermissionsEnum.MANAGE_ALERT_IMPORT,
    PermissionsEnum.MANAGE_ALERT_UPDATE,
    PermissionsEnum.MANAGE_ANALYSE,
    PermissionsEnum.MANAGE_ANALYZER_TEMPLATE,
    PermissionsEnum.MANAGE_CASE_CHANGE_OWNERSHIP,
    PermissionsEnum.MANAGE_CASE_CREATE,
    PermissionsEnum.MANAGE_CASE_DELETE,
    PermissionsEnum.MANAGE_CASE_MERGE,
    PermissionsEnum.MANAGE_CASE_UPDATE,
    PermissionsEnum.MANAGE_CASE_TEMPLATE,
    PermissionsEnum.MANAGE_COMMENT,
    PermissionsEnum.MANAGE_CONFIG,
    PermissionsEnum.MANAGE_CUSTOM_EVENT,
    PermissionsEnum.MANAGE_CUSTOM_FIELD,
    PermissionsEnum.MANAGE_FUNCTION_CREATE,
    PermissionsEnum.MANAGE_FUNCTION_INVOKE,
    PermissionsEnum.MANAGE_CASE_REPORT,
    PermissionsEnum.MANAGE_CASE_REPORT_TEMPLATE,
    PermissionsEnum.MANAGE_KNOWLEDGE_BASE,
    PermissionsEnum.MANAGE_OBSERVABLE,
    PermissionsEnum.MANAGE_OBSERVABLE_TEMPLATE,
    PermissionsEnum.MANAGE_ORGANISATION,
    PermissionsEnum.MANAGE_PAGE,
    PermissionsEnum.MANAGE_PAGE_TEMPLATE,
    PermissionsEnum.MANAGE_PATTERN,
    PermissionsEnum.MANAGE_PLATFORM,
    PermissionsEnum.MANAGE_PROCEDURE,
    PermissionsEnum.MANAGE_PROFILE,
    PermissionsEnum.MANAGE_REPORT_TEMPLATE,
    PermissionsEnum.MANAGE_SHARE,
    PermissionsEnum.MANAGE_TAG,
    PermissionsEnum.MANAGE_TASK,
    PermissionsEnum.MANAGE_TAXONOMY,
    PermissionsEnum.MANAGE_USER,
];
var AdminPermissionsEnum;
(function (AdminPermissionsEnum) {
    AdminPermissionsEnum["MANAGE_ANALYZER_TEMPLATE"] = "manageAnalyzerTemplate";
    AdminPermissionsEnum["MANAGE_CASE_TEMPLATE"] = "manageCaseTemplate";
    AdminPermissionsEnum["MANAGE_CONFIG"] = "manageConfig";
    AdminPermissionsEnum["MANAGE_CUSTOM_FIELD"] = "manageCustomField";
    AdminPermissionsEnum["MANAGE_OBSERVABLE_TEMPLATE"] = "manageObservableTemplate";
    AdminPermissionsEnum["MANAGE_ORGANISATION"] = "manageOrganisation";
    AdminPermissionsEnum["MANAGE_PATTERN"] = "managePattern";
    AdminPermissionsEnum["MANAGE_PLATFORM"] = "managePlatform";
    AdminPermissionsEnum["MANAGE_PROFILE"] = "manageProfile";
    AdminPermissionsEnum["MANAGE_TAG"] = "manageTag";
    AdminPermissionsEnum["MANAGE_TAXONOMY"] = "manageTaxonomy";
    AdminPermissionsEnum["MANAGE_USER"] = "manageUser";
})(AdminPermissionsEnum = exports.AdminPermissionsEnum || (exports.AdminPermissionsEnum = {}));
exports.AdminPermissionsValues = [
    AdminPermissionsEnum.MANAGE_ANALYZER_TEMPLATE,
    AdminPermissionsEnum.MANAGE_CASE_TEMPLATE,
    AdminPermissionsEnum.MANAGE_CONFIG,
    AdminPermissionsEnum.MANAGE_CUSTOM_FIELD,
    AdminPermissionsEnum.MANAGE_OBSERVABLE_TEMPLATE,
    AdminPermissionsEnum.MANAGE_ORGANISATION,
    AdminPermissionsEnum.MANAGE_PATTERN,
    AdminPermissionsEnum.MANAGE_PLATFORM,
    AdminPermissionsEnum.MANAGE_PROFILE,
    AdminPermissionsEnum.MANAGE_TAG,
    AdminPermissionsEnum.MANAGE_TAXONOMY,
    AdminPermissionsEnum.MANAGE_USER,
];
var OrgPermissionsEnum;
(function (OrgPermissionsEnum) {
    OrgPermissionsEnum["MANAGE_ACTION"] = "manageAction";
    OrgPermissionsEnum["MANAGE_ALERT_CREATE"] = "manageAlert/create";
    OrgPermissionsEnum["MANAGE_ALERT_DELETE"] = "manageAlert/delete";
    OrgPermissionsEnum["MANAGE_ALERT_IMPORT"] = "manageAlert/import";
    OrgPermissionsEnum["MANAGE_ALERT_UPDATE"] = "manageAlert/update";
    OrgPermissionsEnum["MANAGE_ANALYSE"] = "manageAnalyse";
    OrgPermissionsEnum["MANAGE_CASE_CHANGE_OWNERSHIP"] = "manageCase/changeOwnership";
    OrgPermissionsEnum["MANAGE_CASE_CREATE"] = "manageCase/create";
    OrgPermissionsEnum["MANAGE_CASE_DELETE"] = "manageCase/delete";
    OrgPermissionsEnum["MANAGE_CASE_MERGE"] = "manageCase/merge";
    OrgPermissionsEnum["MANAGE_CASE_UPDATE"] = "manageCase/update";
    OrgPermissionsEnum["MANAGE_CASE_TEMPLATE"] = "manageCaseTemplate";
    OrgPermissionsEnum["MANAGE_COMMENT"] = "manageComment";
    OrgPermissionsEnum["MANAGE_CUSTOM_EVENT"] = "manageCustomEvent";
    OrgPermissionsEnum["MANAGE_FUNCTION_CREATE"] = "manageFunction/create";
    OrgPermissionsEnum["MANAGE_FUNCTION_INVOKE"] = "manageFunction/invoke";
    OrgPermissionsEnum["MANAGE_CASE_REPORT"] = "manageCaseReport";
    OrgPermissionsEnum["MANAGE_CASE_REPORT_TEMPLATE"] = "manageCaseReportTemplate";
    OrgPermissionsEnum["MANAGE_KNOWLEDGE_BASE"] = "manageKnowledgeBase";
    OrgPermissionsEnum["MANAGE_OBSERVABLE"] = "manageObservable";
    OrgPermissionsEnum["MANAGE_PAGE"] = "managePage";
    OrgPermissionsEnum["MANAGE_PAGE_TEMPLATE"] = "managePageTemplate";
    OrgPermissionsEnum["MANAGE_PROCEDURE"] = "manageProcedure";
    OrgPermissionsEnum["MANAGE_REPORT_TEMPLATE"] = "manageReportTemplate";
    OrgPermissionsEnum["MANAGE_SHARE"] = "manageShare";
    OrgPermissionsEnum["MANAGE_TASK"] = "manageTask";
    OrgPermissionsEnum["MANAGE_USER"] = "manageUser";
})(OrgPermissionsEnum = exports.OrgPermissionsEnum || (exports.OrgPermissionsEnum = {}));
exports.OrgPermissionsValues = [
    OrgPermissionsEnum.MANAGE_ACTION,
    OrgPermissionsEnum.MANAGE_ALERT_CREATE,
    OrgPermissionsEnum.MANAGE_ALERT_DELETE,
    OrgPermissionsEnum.MANAGE_ALERT_IMPORT,
    OrgPermissionsEnum.MANAGE_ALERT_UPDATE,
    OrgPermissionsEnum.MANAGE_ANALYSE,
    OrgPermissionsEnum.MANAGE_CASE_TEMPLATE,
    OrgPermissionsEnum.MANAGE_CASE_CHANGE_OWNERSHIP,
    OrgPermissionsEnum.MANAGE_CASE_CREATE,
    OrgPermissionsEnum.MANAGE_CASE_DELETE,
    OrgPermissionsEnum.MANAGE_CASE_MERGE,
    OrgPermissionsEnum.MANAGE_CASE_UPDATE,
    OrgPermissionsEnum.MANAGE_COMMENT,
    OrgPermissionsEnum.MANAGE_CUSTOM_EVENT,
    OrgPermissionsEnum.MANAGE_FUNCTION_CREATE,
    OrgPermissionsEnum.MANAGE_FUNCTION_INVOKE,
    OrgPermissionsEnum.MANAGE_CASE_REPORT,
    OrgPermissionsEnum.MANAGE_CASE_REPORT_TEMPLATE,
    OrgPermissionsEnum.MANAGE_KNOWLEDGE_BASE,
    OrgPermissionsEnum.MANAGE_OBSERVABLE,
    OrgPermissionsEnum.MANAGE_PAGE,
    OrgPermissionsEnum.MANAGE_PAGE_TEMPLATE,
    OrgPermissionsEnum.MANAGE_PROCEDURE,
    OrgPermissionsEnum.MANAGE_REPORT_TEMPLATE,
    OrgPermissionsEnum.MANAGE_SHARE,
    OrgPermissionsEnum.MANAGE_TASK,
    OrgPermissionsEnum.MANAGE_USER,
];
